export { adgAdConfig } from './ad';

// デフォルト設定
export const defaultInitConfig = {
    id: '',
    name: '',
    title: '',
    genre: '',
    ratio: 1,
    recalculateRatio: null,
    skipcnt: 5,
    reloadcnt: 3,
    targetOrigin: window.location.origin,
    adparam: {
        // key: { elemId: 'ad_id', mid: 'xxxxxx', asid: 'xxxxxx' }
        gaming: {},
        ready: {},
        result: {},
        retry: {},
        reward: {},
    },
};

// adparamの中でインステ広告のもの
export const interstitialAdType = ['ready', 'retry', 'reward'];

// オブザーバーに登録するイベントタイプ
// キーがgameから始まるものはゲームiframeからpostMessageされるactionと同じ
export const message = {
    windowLandscape: 'window:landscape',
    windowPortrait: 'window:portrait',
    resultClickRetry: 'result:click:retry',
    fullscreenAdClickSkip: 'fullscreenAd:click:skip',
    mainRetry: 'habits:retry',
    mainAdjusted: 'habits:adjusted',
    gameClickStart: 'game:click:start',
    gameStart: 'game:start',
    gameReady: 'game:ready',
    gameEnd: 'game:end',
    gameRetry: 'game:retry',
    gameReward: 'game:reward',
    gameLoad: 'game:load',
};

// GAイベント
export const ga = {
    category: {
        click: {
            gamePlay: '【click】ゲーム画面',
            gameStart: '【click】ゲーム開始画面',
            gameResult: '【click】ゲーム結果画面',
            fullscreenAd: '【click】全画面広告',
        },
    },
};

// 広告枠
export const adType = {
    ready: 'ready',
    gamingLarge: 'gamingLarge',
    gamingSmall: 'gamingSmall',
    result: 'result',
    retry: 'retry',
    reward: 'reward',
};
